const createState = () => ({
  sort: {
    name: 'id',
    descending: true
  }
})

const createMutations = () => ({
  SET_SORT: (state, sort) => {
    state.sort = sort
  }
})

const createActions = () => ({
  async loadSorted ({ store, commit, dispatch }, sort) {
    commit('SET_SORT', sort)
    await dispatch('loadList')
  }
})

const vuexSortBase = {
  createState,
  createMutations,
  createActions
}

export {
  vuexSortBase
}
